var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"top"},[_c('li',{staticClass:"top__title"},[(_vm.title)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.copy)?_c('span',[_vm._v(_vm._s(_vm.copy))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }